import { render, staticRenderFns } from "./fullDiscount.vue?vue&type=template&id=01baab6f&"
import script from "./fullDiscount.vue?vue&type=script&lang=js&"
export * from "./fullDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports